/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const DASHBOARD = "/";
export const CUSTOMER = "/customer";
export const CUSTOMER_DETAILS = `${CUSTOMER}/:customerId`;
export const CUSTOMER_NEW = `${CUSTOMER}/new`;
export const ORDER = "/orders";
export const ORDER_DETAIL = `${ORDER}/:orderId`;
export const SHOP_ON_BEHALF = "/shop-on-behalf";
export const CLIENT = "/client";
export const RESEND_ORDER = "/resend-order";
export const PRODUCTS_REPORT = "/products-report";
export const INVENTORY_REPORT = "/inventory-report";
export const PRICES_REPORT = "/prices-report";
export const CLIENTS_REPORT = "/clients-report";
export const SALES_REPORT = "/sales-report";
export const TOP_CLIENTS = "/top-clients";
export const TOP_PRODUCTS = "/top-products";
export const PROMOTIONS_REPORT = "/promotions-report";
export const AUDIT_ORDER_REPORT = "/audit-order-report";
export const INVENTORY = "/inventory";

export const USER_ACTIVATE_ACCOUNT = "/activate-account";
